<template>
    <div ref="accordion_component" class="accordion" @click="onToggle">

        <div role="button" class="">
            <slot name="link"></slot>
        </div>

        <div class="" v-show="openLocal">
            <slot name="dropdown"></slot>
        </div>

    </div>
</template>

<script>
  /*
  Usage:
  <accordion :open="[default false]">
      <span slot="link">
        ...
      </span>
      <div slot="dropdown">
        ...
      </div>
  </accordion>
  */

  export default {
    name: 'accordion',
    data() {
      return {
        openLocal: this.open
      }
    },
    props: {
      open: {
        default: false,
        type: Boolean
      }
    },
    methods: {
      onToggle() {
        this.openLocal = !this.openLocal
      },

      hide(){
        this.openLocal = false
      },

      show(){
        this.openLocal = true
      }
    },

    mounted() {
    },
  }</script>

<style scoped lang="scss">

</style>